/**
 * SEO Component
 * Sets document title and meta tags for SEO optimization
 */

import { useEffect } from 'react';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  ogImage?: string;
  ogUrl?: string;
}

export const SEO: React.FC<SEOProps> = ({
  title = 'OKR Hub by HR4India - Turn Strategy into Focus. Focus into Execution.',
  description = 'OKR Hub by HR4India helps organizations implement OKRs that drive clarity, ownership, and execution—through consulting, managed services, and OKR software.',
  keywords = 'OKR consulting services, OKR software India, OKR implementation consulting, OKR performance management, OKR managed services, OKR framework for organizations, OKR Hub, goal alignment software, strategic execution platform',
  ogImage = '/og-image.jpg',
  ogUrl = 'https://hr4india.com'
}) => {
  useEffect(() => {
    // Set document title
    document.title = title;

    // Helper function to set or update meta tags
    const setMetaTag = (name: string, content: string, isProperty = false) => {
      const attribute = isProperty ? 'property' : 'name';
      let meta = document.querySelector(`meta[${attribute}="${name}"]`);

      if (meta) {
        meta.setAttribute('content', content);
      } else {
        meta = document.createElement('meta');
        meta.setAttribute(attribute, name);
        meta.setAttribute('content', content);
        document.head.appendChild(meta);
      }
    };

    // Standard meta tags
    setMetaTag('description', description);
    setMetaTag('keywords', keywords);
    setMetaTag('author', 'HR4India');

    // Open Graph meta tags for social media
    setMetaTag('og:title', title, true);
    setMetaTag('og:description', description, true);
    setMetaTag('og:type', 'website', true);
    setMetaTag('og:url', ogUrl, true);
    setMetaTag('og:image', ogImage, true);
    setMetaTag('og:site_name', 'HR4India', true);

    // Twitter Card meta tags
    setMetaTag('twitter:card', 'summary_large_image');
    setMetaTag('twitter:title', title);
    setMetaTag('twitter:description', description);
    setMetaTag('twitter:image', ogImage);

    // Additional SEO tags
    setMetaTag('robots', 'index, follow');
    setMetaTag('language', 'English');
    setMetaTag('revisit-after', '7 days');
    setMetaTag('geo.region', 'IN-MH'); // Maharashtra, India
    setMetaTag('geo.placename', 'Mumbai');

  }, [title, description, keywords, ogImage, ogUrl]);

  return null;
};
